export default function reloadPage(): void {
    self.location.reload();
}
